import React from 'react';

const costMultipleIcon = ({
  fill = '#ffffff',
  width = '24.596',
  height = '23.936'
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Group_315"
    width={width}
    height={height}
    data-name="Group 315"
    viewBox="0 0 24.596 23.936"
  >
    <defs>
      <clipPath id="clip-path">
        <path
          id="Rectangle_44"
          d="M0 0h24.596v23.936H0z"
          className="cls-1"
          data-name="Rectangle 44"
        />
      </clipPath>
    </defs>
    <g id="Group_314" data-name="Group 314">
      <g id="Group_313" data-name="Group 313">
        <g id="Group_312" className="cls-2" data-name="Group 312">
          <path
            id="Path_383"
            d="M12.395-4.107a.383.383 0 0 1 .43.437.383.383 0 0 1-.43.436h-3.12a.383.383 0 0 1-.43-.436.5.5 0 0 1 .082-.3l2.59-3.475H9.183a.383.383 0 0 1-.429-.436.383.383 0 0 1 .429-.437H12.3a.383.383 0 0 1 .429.437.483.483 0 0 1-.082.3l-2.576 3.474z"
            className="cls-3"
            data-name="Path 383"
            transform="translate(2.479 21.286)"
            fill={fill}
          />
          <path
            id="Path_384"
            d="M14.332-3.68a.451.451 0 0 1 .334.134.466.466 0 0 1 .132.339.472.472 0 0 1-.132.335.443.443 0 0 1-.334.138h-.677a.443.443 0 0 1-.334-.138.472.472 0 0 1-.132-.335v-1.978l-.11.121a.447.447 0 0 1-.33.138.445.445 0 0 1-.329-.138.464.464 0 0 1-.137-.335.5.5 0 0 1 .128-.334l.778-.781V-9.4a.479.479 0 0 1 .132-.343.444.444 0 0 1 .334-.139.45.45 0 0 1 .33.139.471.471 0 0 1 .137.343v1.951l.219-.223a.488.488 0 0 1 .329-.139.45.45 0 0 1 .33.139.46.46 0 0 1 .137.334.5.5 0 0 1-.128.335l-.888.883v2.44z"
            className="cls-3"
            data-name="Path 384"
            transform="translate(3.479 20.785)"
            fill={fill}
          />
          <path
            id="Path_385"
            d="M7.8-2.106a7.554 7.554 0 0 0 4.249 5.334 7.532 7.532 0 0 0 9.433-3.59c2.109-4.371-1.037-10.577-6.441-10.7h-.189a6.906 6.906 0 0 0-2.444.482h-.009l-.821.4-.266.129-.572.4-.448.314-.813.792-.007.008a6.848 6.848 0 0 0-1.46 2.448l-.254.849-.034.113a6.421 6.421 0 0 0-.067 2.191l.024.336.119.48zm-.92-3.9l-.2.813a22.713 22.713 0 0 1-3.7-.246 6.056 6.056 0 0 1-1.615-.394v2.011c.039.474 1.108.593 2.03.722a19.829 19.829 0 0 0 3.11.2v-.008A8.12 8.12 0 0 1 6.681-5.2zm-5.521-.083zm-.048-.149v.007zm-.122-.142l.016.014zm-.108-.059zm-.033-.01zm-.011 0zm.322-2.759zm-.008-.042v-.006zm-.012-.042a.082.082 0 0 1 .005.015c0-.005 0-.011-.005-.017zm-.009-.026zm-.05-.09a.447.447 0 0 1 .039.065.48.48 0 0 0-.038-.062zm-.007-.01v.006zm-.013-.016v.005zm-.022-.023h.005zm-.008-.011zm-.045-.037l.022.017zm-.059-.036a.356.356 0 0 1 .057.035.356.356 0 0 0-.058-.035zm-.013-.006zm-.03-.013zm-.022-.008zm-.007 0zm-.008 0zm-.018-.005h.013zm.27-5.255c-.008.556-.022 1.113.005 1.668.038.474 1.108.593 2.03.722a18.726 18.726 0 0 0 7.456-.325c.267-.073.6-.162.726-.4v-1.571a8.564 8.564 0 0 1-3.374.708 13.736 13.736 0 0 1-6.661-.714 3.047 3.047 0 0 1-.18-.092zm5.1-2a10.256 10.256 0 0 0-4.687.75c-.232.12-.562.174-.156.441 1.262.832 3.017.829 4.773.841a10.841 10.841 0 0 0 4.871-.737c.2-.1.554-.182.234-.418a5.582 5.582 0 0 0-2.624-.74 19.041 19.041 0 0 0-2.409-.143zm6.009 5a7.2 7.2 0 0 1 2.546-.431 8.8 8.8 0 0 1 8.286 6.949 8.945 8.945 0 0 1-5.032 9.64A8.737 8.737 0 0 1 7.26.164a6.7 6.7 0 0 1-.647-2.239 22.275 22.275 0 0 1-3.635-.245C1.907-2.473.56-2.708.541-3.832v-2.214a.358.358 0 0 1 .2-.326l-.2-.582v-2.214a.356.356 0 0 1 .2-.327l.273-.086-.273.086-.2-.582v-2.213a.445.445 0 0 1 .115-.28 1.118 1.118 0 0 1-.175-.6v-2.215a.45.45 0 0 1 .079-.235.8.8 0 0 1 .04-.5c.258-.661 1.028-.874 1.629-1.05a15.239 15.239 0 0 1 4.315-.5c1.791.009 3.687-.008 5.225.936a1.144 1.144 0 0 1 .542 1.21.445.445 0 0 1 .03.136c0 .744.008 1.487 0 2.23a.916.916 0 0 1-.173.5.451.451 0 0 1 .234.368v.465l-.821.28v-.629a2.43 2.43 0 0 1-.422.17 19.987 19.987 0 0 1-8.24.344 6.364 6.364 0 0 1-1.556-.366c-.006.651-.031 1.305 0 1.957.039.474 1.108.593 2.03.722a19.813 19.813 0 0 0 5.168.09l-.609.88a21.65 21.65 0 0 1-4.975-.186 6.056 6.056 0 0 1-1.615-.394v2.011c.039.474 1.108.593 2.03.722a20.937 20.937 0 0 0 3.491.208v-.009a8.321 8.321 0 0 1 1.07-2.352l.609-.88.008-.01a7.765 7.765 0 0 1 2.739-2.184l.271-.093.821-.28z"
            className="cls-4"
            data-name="Path 385"
            transform="translate(.136 18.304)"
            fill={fill}
          />
        </g>
      </g>
    </g>
  </svg>
);

export default costMultipleIcon;
